import { NgForOf, NgIf } from "@angular/common";
import { Component, OnInit } from '@angular/core';
import { RouterLink } from "@angular/router";
import { KursInfoApiService, KursInfoVO, TeilnehmerVO, UserInfoVO } from "@core/api/v1";
import { KurslisteItemComponent } from "@core/views/kursliste/kursliste-item/kursliste-item.component";
import { LoginService } from "@core/services/login/login.service";
import { PaginatorModule, PaginatorState } from "primeng/paginator";

@Component({
    selector: 'app-kursliste',
    standalone: true,
    imports: [
        KurslisteItemComponent,
        NgForOf,
        PaginatorModule,
        NgIf,
        RouterLink,
    ],
    templateUrl: './kursliste.component.html',
    styleUrl: './kursliste.component.scss',
})
export class KurslisteComponent implements OnInit {
    kursItems: KursInfoVO[] = [];
    first: number = 0;
    page: number = 0;
    rows: number = 10;
    totalRecords: number = 0;
    teilnehmer: UserInfoVO;

    constructor(private kursService: KursInfoApiService, private loginService: LoginService) {
    }

    ngOnInit(): void {
        this.loadKurse();
        this.teilnehmer = this.loginService.holeEingeloggtenUser();
    }

    onPageChange(event: PaginatorState) {
        this.first = event.first as number;
        this.rows = event.rows as number;
        this.page = event.page as number;
        this.loadKurse();
        window.scroll(0, 0);
    }

    loadKurse() {
        this.kursService.holeKurse(this.page, this.rows).subscribe(data => {
                this.kursItems = data.kursInfoVOList!;
                this.totalRecords = data.pageInfoVO?.total!;
            },
        );
    }
}
